/* TAGUS LANE · The Red Fold storefront behaviour. Progressive enhancement: every route works without this file. */
(function () {
  'use strict';

  /* ---------- Pure logic (also exercised by the Node tests) ---------- */
  var Logic = {
    // Linked Tagus Lane box lines must never outnumber, or outlive, the gift they belong to.
    boxFixes: function (items) {
      var fixes = [];
      var parents = {};
      items.forEach(function (it) {
        var p = it.properties || {};
        if (p._rf_link && !p._rf_box) parents[p._rf_link] = (parents[p._rf_link] || 0) + it.quantity;
      });
      items.forEach(function (it) {
        var p = it.properties || {};
        if (!p._rf_box) return;
        var have = parents[p._rf_link] || 0;
        if (have === 0) fixes.push({ key: it.key, quantity: 0, reason: 'orphan', name: p.For || '' });
        else if (it.quantity > have) fixes.push({ key: it.key, quantity: have, reason: 'clamp', name: p.For || '' });
      });
      return fixes;
    },
    // Variant whose option values equal the selection.
    findVariant: function (variants, selected) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < selected.length; j++) if (v.options[j] !== selected[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    },
    // Finder: deterministic filter over public tags and price (minor units, presentment currency).
    matches: function (items, ans, rate) {
      rate = rate || 1;
      return items.filter(function (p) {
        if (!p.available) return false;
        if (ans.person && p.tags.indexOf('for-' + ans.person) < 0) return false;
        if (ans.occasion && p.tags.indexOf('occasion-' + ans.occasion) < 0 && p.tags.indexOf('occasion-any') < 0) return false;
        if (ans.budget) {
          var b = Logic.band(ans.budget, rate), lo = b[0], hi = b[1];
          if (p.price < lo) return false;
          if (hi > 0 && p.price >= hi) return false;
        }
        return true;
      });
    },
    // Budget band edges (EUR minor units in the key) in the visitor's currency, rounded to a whole unit that suits it,
    // so labels read as round numbers and the filter uses exactly the edges the label shows.
    band: function (key, rate) {
      rate = rate || 1;
      var r = String(key).split('-'), u = rate >= 100 ? 100000 : rate >= 10 ? 1000 : 100;
      var edge = function (v) { return Math.round(Number(v) * rate / u) * u; };
      return [edge(r[0]), edge(r[1])];
    },
    // Business days after a date (Mon-Fri), conservative for both preparation and transit.
    addBusinessDays: function (date, n) {
      var d = new Date(date.getTime()), k = 0;
      while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
      return d;
    },
    parseList: function (s) {
      return String(s || '').split('|').filter(Boolean).map(function (e) { var i = e.indexOf(':'); return { key: e.slice(0, i), label: e.slice(i + 1) }; });
    }
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = Logic; return; }
  if (typeof document === 'undefined') return;

  /* ---------- Helpers ---------- */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = {};
  try { cfg = JSON.parse(($('#rf-config') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  // The shop's money format is rendered per request in the visitor's currency, so prices drawn here match the
  // server-rendered ones. Each placeholder: [decimals, thousands separator, decimal separator].
  var MONEY = { amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'], amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','], amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','], amount_with_apostrophe_separator: [2, "'", '.'] };
  function money(cents) {
    var cur = cfg.currency || 'EUR';
    if (cfg.moneyFormat && /\{\{\s*\w+\s*\}\}/.test(cfg.moneyFormat)) {
      return cfg.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        var o = MONEY[k] || MONEY.amount, p = (Math.round(cents) / 100).toFixed(o[0]).split('.');
        return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, o[1]) + (p[1] ? o[2] + p[1] : '');
      }).replace(/<[^>]+>/g, '');
    }
    try { return new Intl.NumberFormat('en-IE', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  // Motion is opt-in from this file: if it never runs, nothing waits hidden for an animation.
  if (!reduced) document.documentElement.classList.add('rf-anim');
  // Roll a short value (counts, indexes): the old one leaves, the new one arrives. Transform only.
  function roll(el, text, up) {
    if (!el) return;
    var cur = el.getAttribute('data-v');
    if (cur === String(text)) return;
    el.setAttribute('data-v', text);
    if (reduced || cur == null) { el.textContent = text; return; }
    el.innerHTML = '<span class="rf-roll__o" aria-hidden="true">' + esc(cur) + '</span><span class="rf-roll__n">' + esc(text) + '</span>';
    el.classList.remove('is-up', 'is-down'); void el.offsetWidth; el.classList.add(up ? 'is-up' : 'is-down');
    clearTimeout(el.__t); el.__t = setTimeout(function () { var o = el.querySelector('.rf-roll__o'); if (o) el.removeChild(o); el.classList.remove('is-up', 'is-down'); }, 640);
  }
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* analytics optional */ } }
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    var openDlg = $$('dialog[open]')[0];
    if (openDlg && t.parentNode !== openDlg) openDlg.appendChild(t); else if (!openDlg && t.parentNode !== document.body) document.body.appendChild(t);
    if (!msg || /failed to fetch|networkerror|load failed/i.test(msg)) msg = 'That did not go through. Check your connection and try again.';
    t.textContent = msg; t.hidden = false; clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4200);
  }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- Header: solid on scroll, panels, mobile menu ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    var toggles = $$('[data-panel-toggle]', header);
    var closePanels = function (except) {
      toggles.forEach(function (b) { if (b === except) return; b.setAttribute('aria-expanded', 'false'); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = true; });
      header.classList.toggle('is-open', !!except);
    };
    toggles.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        closePanels(open ? null : b);
        b.setAttribute('aria-expanded', String(!open));
        var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = open;
      });
    });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closePanels(null); });
    header.addEventListener('focusout', function (e) { var to = e.relatedTarget; if (!to || !header.contains(to)) { closePanels(null); return; } var open = toggles.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0]; if (open) { var p = document.getElementById(open.getAttribute('aria-controls')); if (to !== open && p && !p.contains(to)) closePanels(null); } });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openBtn = toggles.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
      closePanels(null); if (openBtn) openBtn.focus();
      if (menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') { setMenu(false); menuBtn.focus(); }
    });
    var menuBtn = $('[data-menu-toggle]', header), menu = $('[data-menu]', header);
    var outside = function () { return $$('main, .shopify-section-group-footer-group, footer').concat($$('.rf-header__brand, .rf-header__search, .rf-bag', header)); };
    var setMenu = function (on) {
      if (!menuBtn) return; menuBtn.setAttribute('aria-expanded', String(on)); menu.hidden = !on; header.classList.toggle('is-open', on); lockScroll(on);
      outside().forEach(function (el) { if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); });
      // Focus lands on the menu itself, not the search field, so opening it never raises the phone keyboard.
      if (on) menu.focus({ preventScroll: true });
    };
    if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a[href]')) setMenu(false); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { if (menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') setMenu(false); closePanels(null); } });
    if (menu) menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = [menuBtn].concat($$('a, button, input', menu)); var i = items.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); items[items.length - 1].focus(); } else if (!e.shiftKey && i === items.length - 1) { e.preventDefault(); menuBtn.focus(); }
    });
    if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'); });
    window.matchMedia('(min-width: 900px)').addEventListener('change', function () { setMenu(false); });
  }

  /* ---------- Dialogs ---------- */
  function openDialog(d) { if (!d) return; if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', ''); lockScroll(true); }
  function closeDialog(d) { if (!d) return; if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); lockScroll(false); }
  $$('dialog').forEach(function (d) {
    d.addEventListener('close', function () { lockScroll(false); });
    d.addEventListener('click', function (e) { if (e.target === d) closeDialog(d); });
    $$('[data-close]', d).forEach(function (b) { b.addEventListener('click', function () { closeDialog(d); }); });
  });

  /* ---------- Search with predictive suggestions ---------- */
  var searchPanel = $('[data-search-panel]');
  $$('[data-open-search]').forEach(function (b) { b.addEventListener('click', function () { openDialog(searchPanel); var i = $('[data-predictive]', searchPanel); if (i) i.focus(); }); });
  var pInput = $('[data-predictive]'), pOut = $('[data-predictive-results]'), pTimer, pCtrl;
  if (pInput && pOut) {
    pInput.addEventListener('input', function () {
      clearTimeout(pTimer);
      var q = pInput.value.trim();
      if (!q) { pOut.innerHTML = ''; return; }
      pTimer = setTimeout(function () {
        if (pCtrl) pCtrl.abort(); pCtrl = window.AbortController ? new AbortController() : null;
        pOut.innerHTML = '<p class="rf-small">Searching…</p>';
        fetch((cfg.routes && cfg.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page&resources[limit]=8&resources[options][unavailable_products]=last', pCtrl ? { signal: pCtrl.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error('search'); return r.json(); })
          .then(function (j) {
            var res = (j && j.resources && j.resources.results) || {};
            var prods = res.products || [], pages = res.pages || [];
            var url = (cfg.routes && cfg.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
            if (!prods.length && !pages.length) { pOut.innerHTML = '<p>No gifts match “' + esc(q) + '”. <a href="/pages/gifts">Start from the person</a> or <a href="/collections/all">see every gift</a>.</p>'; return; }
            var h = '<div class="rf-grid">' + prods.map(function (p) {
              var cutSrc = (cfg.cutouts || {})[p.handle];
              var img = cutSrc ? '<img class="rf-card__img is-cutout" src="' + esc(cutSrc) + '" alt="" loading="lazy">' : p.featured_image && p.featured_image.url ? '<img class="rf-card__img" src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=480" alt="" loading="lazy">' : '<span class="rf-card__ph">' + esc(p.title) + '</span>';
              var price = p.price ? '<span class="rf-card__price">' + esc(money(Math.round(parseFloat(p.price) * 100))) + '</span>' : '';
              return '<a class="rf-card" href="' + esc(p.url) + '"><span class="rf-card__media' + (cutSrc ? ' is-cutout' : '') + '">' + img + '</span><span class="rf-card__name">' + esc(p.title) + '</span>' + price + '</a>';
            }).join('') + '</div>';
            if (pages.length) h += '<div class="rf-index">' + pages.map(function (p) { return '<a class="rf-index__a" href="' + esc(p.url) + '"><span>' + esc(p.title) + '</span></a>'; }).join('') + '</div>';
            h += '<p class="rf-search__more"><a class="rf-textlink" href="' + url + '">See all results</a></p>';
            pOut.innerHTML = h;
          })
          .catch(function (e) { if (e.name !== 'AbortError') pOut.innerHTML = '<p>Suggestions are unavailable right now. Press Enter to search.</p>'; });
      }, 180);
    });
  }

  /* ---------- Cart ---------- */
  var drawer = $('[data-cart-drawer]');
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }); }
  function change(key, qty) {
    return fetch((cfg.routes && cfg.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'This change could not be saved.'); return j; }); });
  }
  function reconcile(cart) {
    var fixes = Logic.boxFixes(cart.items || []);
    if (!fixes.length) return Promise.resolve(cart);
    return fixes.reduce(function (p, f) { return p.then(function () { return change(f.key, f.quantity); }); }, Promise.resolve())
      .then(function () {
        var f = fixes[0];
        toast(f.reason === 'orphan' ? 'The Tagus Lane box' + (f.name ? ' for ' + f.name : '') + ' was removed with its gift.' : 'The Tagus Lane box quantity now matches its gift.');
        return getCart().then(function (c) { c.__fixed = true; return c; });
      });
  }
  function lineHTML(it) {
    var props = it.properties || {}, extra = '';
    Object.keys(props).forEach(function (k) { if (k.charAt(0) !== '_' && props[k]) extra += '<p class="rf-line__var">' + esc(k) + ': ' + esc(props[k]) + '</p>'; });
    var cutSrc = (cfg.cutouts || {})[it.handle];
    var img = cutSrc ? '<img class="is-cutout" src="' + esc(cutSrc) + '" alt="" loading="lazy">' : it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '';
    var isBox = !!props._rf_box;
    return '<li class="rf-line" data-key="' + esc(it.key) + '">' +
      '<a class="rf-line__img" href="' + esc(it.url) + '" tabindex="-1">' + img + '</a>' +
      '<div class="rf-line__body"><a class="rf-line__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      (it.product_has_only_default_variant ? '' : '<p class="rf-line__var">' + esc(it.variant_title || '') + '</p>') + extra +
      '<div class="rf-line__row"><div class="rf-qty" data-line-qty>' +
      '<button type="button" class="rf-qty__b" data-step="-1" aria-label="One fewer ' + esc(it.product_title) + '"><svg class="rf-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="1.6"/></svg></button>' +
      '<span class="rf-qty__i num" aria-live="polite">' + it.quantity + '</span>' +
      '<button type="button" class="rf-qty__b" data-step="1" aria-label="One more ' + esc(it.product_title) + '"' + (isBox ? ' data-box-line' : '') + '><svg class="rf-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.6"/></svg></button></div>' +
      '<button type="button" class="rf-textbtn" data-remove>Remove</button><span class="rf-line__price num">' + esc(money(it.final_line_price)) + '</span></div></div></li>';
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var body = $('[data-cart-lines]', drawer), foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="rf-drawer__empty"><p>Your bag is empty.</p><p><a class="rf-btn rf-btn--red" href="/pages/gifts"><span>Find a gift</span></a></p></div>';
      foot.hidden = true; return;
    }
    var act = document.activeElement, keep = act && drawer.contains(act) && act.closest('[data-key]') ? { key: act.closest('[data-key]').getAttribute('data-key'), step: act.getAttribute('data-step') } : null;
    body.innerHTML = '<ul class="rf-lines">' + cart.items.map(lineHTML).join('') + '</ul>';
    if (keep) { var li = body.querySelector('[data-key="' + keep.key + '"]'); var el = li && (keep.step ? li.querySelector('[data-step="' + keep.step + '"]') : li.querySelector('[data-remove]')); (el || body.querySelector('[data-step]') || drawer.querySelector('[data-close]')).focus(); }
    $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    foot.hidden = false;
  }
  // A page restored by Back keeps its old count; ask the cart again.
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(function (c) { setCount(c.item_count); if (drawer && drawer.open) renderCart(c); }).catch(function () {}); });
  function refreshCart() { return getCart().then(reconcile).then(function (c) { renderCart(c); return c; }).catch(function () { toast('Your bag could not be loaded. Please reload the page.'); }); }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var li = e.target.closest('[data-key]'); if (!li) return;
      var key = li.getAttribute('data-key');
      var stepBtn = e.target.closest('[data-step]'), rm = e.target.closest('[data-remove]');
      if (!stepBtn && !rm) return;
      var qtyEl = $('.rf-qty__i', li), q = Number(qtyEl.textContent) || 0;
      var next = rm ? 0 : Math.max(0, q + Number(stepBtn.getAttribute('data-step')));
      li.style.opacity = '.5';
      change(key, next).then(reconcile).then(renderCart).catch(function (err) { li.style.opacity = ''; toast(err.message || 'This change could not be saved.'); });
    });
  }
  $$('[data-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!drawer || typeof drawer.showModal !== 'function' || $('[data-cart-page]')) return;
      e.preventDefault(); openDialog(drawer); refreshCart();
    });
  });
  // Cart page: quantity inputs and removals keep linked boxes consistent, then show the server-rendered truth.
  var cartPage = $('[data-cart-page]');
  if (cartPage) {
    $$('[data-line-qty]', cartPage).forEach(function (inp) {
      inp.addEventListener('change', function () { change(inp.getAttribute('data-line-qty'), Math.max(0, Number(inp.value) || 0)).then(reconcile).then(function () { location.reload(); }).catch(function (err) { toast(err.message); }); });
    });
    $$('[data-line-step]', cartPage).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('[data-line-qty]', b.parentNode); if (!inp) return;
        inp.value = Math.max(0, Math.min(99, (Number(inp.value) || 0) + Number(b.getAttribute('data-line-step'))));
        inp.dispatchEvent(new Event('change'));
      });
    });
    $$('[data-line-remove]', cartPage).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); change(a.getAttribute('data-line-remove'), 0).then(reconcile).then(function () { location.reload(); }).catch(function (err) { toast(err.message); }); });
    });
    getCart().then(reconcile).then(function (c) { if (c && c.__fixed) location.reload(); }).catch(function () {});
  }

  /* ---------- Carousels: showroom and product gallery ---------- */
  function carousel(root) {
    var track = $('[data-track]', root); if (!track) return;
    var slides = $$('[data-slide]', track); if (!slides.length) return;
    var idx = 0, count = $('[data-index]', root), bar = $('[data-bar]', root), cta = $('[data-slide-cta]', root), big = $('[data-big]', root);
    var update = function (i) {
      var up = i >= idx, txt = (i + 1 < 10 ? '0' : '') + (i + 1);
      idx = i;
      if (count) { if (count.classList.contains('rf-roll')) roll(count, txt, up); else count.textContent = txt; }
      if (big) roll(big, txt, up);
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (bar) bar.style.setProperty('--i', i);
      if (cta && slides[i].getAttribute('data-url')) cta.href = slides[i].getAttribute('data-url');
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', String(k !== i)); $$('a', s).forEach(function (a) { a.tabIndex = k === i ? 0 : -1; }); });
    };
    var go = function (i) {
      i = (i + slides.length) % slides.length;
      // relative to the first slide, so the target does not depend on which ancestor is positioned
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      update(i);
    };
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } });
    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== idx && slides[i]) update(i); }, 80); }, { passive: true });
    update(0);
    root.__go = go;
  }
  $$('[data-show] [data-panel]').forEach(carousel);
  // Home sections: headings rise when their section is first seen; items arrive in order, staggered within each batch
  // that comes into view together. Without IntersectionObserver everything is simply shown.
  (function () {
    var els = $$('[data-seen], [data-reveal]');
    var show = function (el) { el.classList.add(el.hasAttribute('data-seen') ? 'is-seen' : 'is-in'); };
    if (!('IntersectionObserver' in window)) { els.forEach(show); return; }
    var io = new IntersectionObserver(function (en) {
      var k = 0;
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (e.target.hasAttribute('data-reveal')) e.target.style.transitionDelay = Math.min(k++, 6) * 70 + 'ms';
        show(e.target); io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();
  // Facts band: the same slow speed (about 36 px a second) whatever the length of the text.
  $$('[data-ticker]').forEach(function (t) {
    var run = $('.rf-ticker__run', t), track = $('.rf-ticker__track', t);
    var set = function () { if (run && track && run.offsetWidth) track.style.setProperty('--dur', Math.max(20, run.offsetWidth / 36).toFixed(1) + 's'); };
    set(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
  });
  // Showroom type rises into place once, when the section first comes into view.
  $$('[data-show]').forEach(function (show) {
    if (!('IntersectionObserver' in window)) { show.classList.add('is-seen'); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); show.classList.add('is-seen'); } }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(show);
  });
  $$('[data-gallery]').forEach(carousel);
  // Showroom tabs (roving tabindex)
  $$('[data-show]').forEach(function (show) {
    var tabs = $$('[role="tab"]', show);
    var select = function (t, focus) {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      if (focus) t.focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length], true); } });
    });
  });

  /* ---------- Product form ---------- */
  $$('[data-product]').forEach(function (root) {
    var data; try { data = JSON.parse($('[data-product-json]', root).textContent); } catch (e) { return; }
    var form = $('[data-product-form]', root), idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add]', root), addLabel = $('[data-add-label]', root), errEl = $('[data-form-error]', root);
    var sets = $$('[data-option]', root).filter(function (f) { return !f.hasAttribute('data-box'); });
    var selected = function () { return sets.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; }); };
    var current = Logic.findVariant(data.variants, selected()) || data.variants[0];
    var packIndex = -1; sets.forEach(function (f, i) { if (f.hasAttribute('data-pack')) packIndex = Number(f.getAttribute('data-option')); });
    function packDeltas() {
      if (packIndex < 0) return;
      var sel = selected(), std = sel.slice(), box = sel.slice();
      var vals = $$('[data-pack-delta]', root).map(function (el) { return el.getAttribute('data-pack-delta'); });
      std[packIndex] = vals[0]; box[packIndex] = vals[vals.length - 1];
      var a = Logic.findVariant(data.variants, std), b = Logic.findVariant(data.variants, box);
      $$('[data-pack-delta]', root).forEach(function (el, i) {
        if (i === 0) { el.textContent = ''; return; }
        el.textContent = a && b ? (b.available ? '+' + money(b.price - a.price) : 'Sold out') : '';
      });
    }
    function sync(fromUser) {
      var v = Logic.findVariant(data.variants, selected());
      sets.forEach(function (f) { var c = $('input:checked', f), lab = $('[data-option-value]', f); if (lab && c) lab.textContent = c.value; });
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Not available in this combination'; return; }
      current = v; idInput.value = v.id;
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? 'Add to bag' : 'Not available now';
      var pr = $('[data-variant-price] .num', root); if (pr) pr.textContent = money(v.price);
      var bp = $('[data-buybar-price]', root); if (bp) bp.textContent = money(v.price);
      var bb = $('[data-buybar-add]', root); if (bb) bb.disabled = !v.available;
      var was = $('[data-variant-price] .rf-price__was', root); if (was) was.hidden = !(v.compare > v.price);
      packDeltas();
      if (fromUser) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        if (v.media) { var g = $('[data-gallery]', root), s = g && $$('[data-slide]', g).findIndex(function (x) { return x.getAttribute('data-media-id') === String(v.media); }); if (s >= 0 && g.__go) g.__go(s); }
      }
    }
    sets.forEach(function (f) { f.addEventListener('change', function () { sync(true); }); });
    sync(false);
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { var i = $('input[name="quantity"]', root); i.value = Math.min(10, Math.max(1, (Number(i.value) || 1) + Number(b.getAttribute('data-qty-step')))); });
    });
    if (!form) return;
    // Phone buy bar: shown while the real Add to bag is above the screen and the footer is not yet in view.
    var bar = $('[data-buybar]', root), foot = $('footer, .shopify-section-group-footer-group');
    if (bar && addBtn) {
      var hh = header ? header.offsetHeight : 60, tick = false;
      var place = function () {
        tick = false;
        var past = addBtn.getBoundingClientRect().bottom < hh, end = foot && foot.getBoundingClientRect().top < window.innerHeight;
        bar.hidden = !(window.innerWidth < 900 && past && !end);
      };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(place); } }, { passive: true });
      window.addEventListener('resize', place, { passive: true });
      $('[data-buybar-add]', bar).addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
    }
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      errEl.hidden = true;
      var qty = Math.min(10, Math.max(1, Number($('input[name="quantity"]', root).value) || 1));
      var items = [{ id: current.id, quantity: qty }];
      var boxIn = $('[data-box] input:checked', root);
      if (boxIn && boxIn.value && cfg.boxMode === 'live') {
        var link = 'L' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        items[0].properties = { _rf_link: link };
        items.push({ id: Number(boxIn.value), quantity: qty, properties: { _rf_link: link, _rf_box: boxIn.getAttribute('data-box-size'), For: data.name } });
      }
      addBtn.classList.add('is-loading'); addBtn.disabled = true;
      fetch((cfg.routes && cfg.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'This piece could not be added.'); return j; }); })
        .then(function () { return refreshCart(); })
        .then(function () { if (drawer && typeof drawer.showModal === 'function') openDialog(drawer); else toast('Added to your bag.'); })
        .catch(function (err) { errEl.textContent = String(err.message || 'This piece could not be added.').replace(/<[^>]+>/g, '') + ' Please try again, or write to us.'; errEl.hidden = false; })
        .then(function () { addBtn.classList.remove('is-loading'); addBtn.disabled = !current.available; });
    });
  });

  /* ---------- Hero: the wordmark decal appears with the photo, never on its own over an empty frame ---------- */
  var heroImg = $('.rf-hero__img');
  if (heroImg) {
    var heroDone = function () { var h = heroImg.closest('.rf-hero'); if (h) h.classList.add('is-loaded'); };
    if (heroImg.complete && heroImg.naturalWidth) heroDone(); else { heroImg.addEventListener('load', heroDone); heroImg.addEventListener('error', heroDone); }
  }

  /* ---------- Related gifts ---------- */
  $$('[data-related]').forEach(function (el) {
    var url = el.getAttribute('data-url'); if (!url || el.children.length) return;
    var go = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html; var s = $('[data-related]', d);
        if (s && s.innerHTML.trim()) el.innerHTML = s.innerHTML;
      }).catch(function () {});
    };
    // Fetched as soon as the page is idle, so the cards are in place before anyone scrolls down and nothing jumps.
    var start = function () { (window.requestIdleCallback || function (cb) { setTimeout(cb, 200); })(go); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  });

  /* ---------- Delivery estimate dates and country ---------- */
  var fmt = function (d) { try { return new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).format(d); } catch (e) { return d.toDateString(); } };
  $$('[data-eta]').forEach(function (el) {
    var h = el.getAttribute('data-h').split(',').map(Number), t = el.getAttribute('data-t').split(',').map(Number);
    var now = new Date(), a = Logic.addBusinessDays(now, h[0] + t[0]), b = Logic.addBusinessDays(now, h[1] + t[1]);
    var out = $('[data-eta-dates]', el);
    if (out) out.textContent = ' Estimated arrival for an order placed today: ' + fmt(a) + ' – ' + fmt(b) + '. An estimate, not a guarantee.';
  });
  $$('[data-open-country]').forEach(function (b) {
    b.addEventListener('click', function () { var s = $('[data-country-select]'); if (!s) { location.href = '/pages/delivery'; return; } s.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); setTimeout(function () { s.focus(); }, reduced ? 0 : 400); });
  });
  // Sort and filters apply as soon as they change; the Apply buttons stay only for visitors without this file.
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { var fm = s.form; if (!fm) return; if (fm.requestSubmit) fm.requestSubmit(); else fm.submit(); }); });
  document.addEventListener('click', function (e) { $$('.rf-filter[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; }); });
  // collection filters: Escape closes an open disclosure and returns focus to it
  $$('.rf-filter').forEach(function (d) { d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { d.open = false; $('summary', d).focus(); } }); });

  /* ---------- Gift finder ---------- */
  var finder = $('[data-finder]');
  if (finder) {
    var catalog = [], tax = {};
    try { catalog = JSON.parse($('#rf-catalog').textContent); tax = JSON.parse($('#rf-taxonomy').textContent); } catch (e) { catalog = []; }
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    var persons = Logic.parseList(tax.persons).map(function (x) { return { key: x.key.replace(/^for-/, ''), label: x.label }; });
    var occasions = Logic.parseList(tax.occasions).map(function (x) { return { key: x.key.replace(/^occasion-/, ''), label: x.label }; });
    var budgets = Logic.parseList(tax.budgets).map(function (x) {
      var r = Logic.band(x.key, rate), lo = r[0], hi = r[1];
      var label = hi > 0 && lo === 0 ? 'Under ' + money(hi) : hi > 0 ? money(lo) + ' to ' + money(hi) : money(lo) + ' and over';
      return { key: x.key, label: label.replace(/[.,]00(?!\d)/g, '') };
    });
    // How each occasion reads inside the results sentence ("6 gifts for her, for a birthday.").
    var OCC = { birthday: 'for a birthday', anniversary: 'for an anniversary', christmas: 'for Christmas', 'thank-you': 'to say thank you', 'just-because': 'just because', valentines: "for Valentine's Day", 'mothers-day': "for Mother's Day", 'fathers-day': "for Father's Day", graduation: 'for a graduation', wedding: 'for a wedding', 'new-home': 'for a new home', 'new-job': 'for a new job' };
    var STEPS = [
      { id: 'person', q: 'Who are you thinking of?', any: { key: '', label: 'Someone else' }, list: persons },
      { id: 'occasion', q: 'What is the occasion?', any: { key: '', label: 'No particular occasion' }, list: occasions },
      { id: 'budget', q: 'What would you like to spend?', any: { key: '', label: 'Any budget' }, list: budgets }
    ];
    var params = new URLSearchParams(location.search);
    var ans = { person: params.get('person') || '', occasion: params.get('occasion') || '', budget: params.get('budget') || '' };
    var answered = { person: params.has('person'), occasion: params.has('occasion'), budget: params.has('budget') };
    var step = answered.budget ? 3 : answered.occasion ? 2 : answered.person ? 1 : 0;
    var stage = $('[data-stage]', finder), results = $('[data-results]', finder), tabs = $$('[data-step-tab]', finder);
    var match = $('[data-match]', finder), matchN = $('[data-match-n]', finder), matchL = $('[data-match-l]', finder), stack = $('[data-match-stack]', finder);
    var ink = $('[data-steps-ink]', finder);
    var hover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var started = false, busy = false, flip = null;
    var label = function (s, k) { var o = STEPS[s].list.filter(function (x) { return x.key === k; })[0]; return o ? o.label : STEPS[s].any.label; };
    var sub = function (upto) { var a = { person: '', occasion: '', budget: '' }; STEPS.slice(0, upto).forEach(function (s) { a[s.id] = ans[s.id]; }); return a; };
    // Words of a heading, each in its own mask so the line can rise into place.
    var words = function (s) { return esc(s).split(' ').map(function (w, i) { return '<span class="rf-w"><span style="--i:' + i + '">' + w + '</span></span>'; }).join(' '); };
    if (match) match.hidden = false;
    finder.classList.add('is-live');

    // Bring the top of the finder under the header when the visitor is below it (after a step, the page may be shorter).
    function toTop() {
      var hh = header ? header.offsetHeight : 60, y = finder.getBoundingClientRect().top + window.scrollY - hh;
      if (window.scrollY > y + 1) { try { window.scrollTo({ top: Math.max(0, y), behavior: 'instant' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); } }
    }
    function pushState() {
      var u = new URL(location.href);
      STEPS.forEach(function (s, i) { if (i < step && answered[s.id]) u.searchParams.set(s.id, ans[s.id]); else u.searchParams.delete(s.id); });
      history.pushState({ step: step, ans: ans }, '', u.toString());
    }
    function placeInk() {
      if (!ink) return;
      var ol = $('[data-steps]', finder), x = 0, w = ol ? ol.offsetWidth : 0;
      if (step < 3) { var li = tabs[step], b = li && $('button', li); if (b) { x = li.offsetLeft + b.offsetLeft; w = b.offsetWidth; } }
      ink.style.transform = 'translateX(' + x + 'px) scaleX(' + (w / 100) + ')';
    }
    function renderTabs() {
      tabs.forEach(function (li, i) {
        var b = $('button', li); li.classList.toggle('is-on', i === step); li.classList.toggle('is-done', i < step);
        b.disabled = i >= step; if (i === step) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      });
      finder.setAttribute('data-at', String(Math.min(step, 3)));
      placeInk();
    }
    // Match panel: the real products that still fit, as tiles that arrive, leave and re-settle.
    var SLOTS = {
      1: [[50, 50, 0, 1.5]],
      2: [[33, 44, -4, 1.15], [67, 58, 4, 1.15]],
      3: [[29, 33, -5, 1], [71, 37, 4, 1], [50, 70, -2, 1]],
      4: [[29, 29, -5, 1], [71, 31, 4, 1], [31, 71, 3, 1], [69, 70, -4, 1]],
      5: [[27, 27, -5, .92], [73, 27, 4, .92], [50, 51, -1, .92], [27, 75, 3, .92], [73, 74, -3, .92]],
      6: [[22, 30, -5, .8], [50, 25, 3, .8], [78, 31, -3, .8], [22, 71, 4, .8], [50, 75, -2, .8], [78, 70, 3, .8]]
    };
    function setMatch(list) {
      if (!match) return;
      var n = list.length, prev = Number(match.getAttribute('data-n'));
      match.setAttribute('data-n', String(n));
      roll(matchN, (n < 10 ? '0' : '') + n, isNaN(prev) || n >= prev);
      matchL.textContent = n === 1 ? 'gift fits so far' : 'gifts fit so far';
      var show = list.slice(0, 6), keep = {}, slots = SLOTS[show.length] || [];
      show.forEach(function (p) { keep[p.id] = true; });
      $$('[data-tile]', stack).forEach(function (t) {
        if (keep[t.getAttribute('data-tile')] || t.classList.contains('is-gone')) return;
        t.classList.add('is-gone');
        setTimeout(function () { if (t.classList.contains('is-gone') && t.parentNode) t.parentNode.removeChild(t); }, reduced ? 0 : 520);
      });
      show.forEach(function (p, i) {
        var t = $('[data-tile="' + p.id + '"]', stack), fresh = !t;
        if (fresh) {
          t = document.createElement('span');
          t.className = 'rf-tile is-new' + (p.cutout ? ' is-cutout' : '');
          t.setAttribute('data-tile', p.id);
          t.innerHTML = '<span class="rf-tile__f">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="600" height="600" decoding="async">' : '<b>' + esc(p.name) + '</b>') + '</span>';
          stack.appendChild(t);
        }
        var s = slots[i] || [50, 50, 0, 1];
        t.classList.remove('is-gone');
        t.setAttribute('data-k', String(i));
        t.style.cssText = '--k:' + i + ';--x:' + s[0] + ';--y:' + s[1] + ';--r:' + s[2] + 'deg;--s:' + s[3];
        if (fresh) { void t.offsetWidth; t.classList.remove('is-new'); }
      });
    }
    function preview(key) {
      if (step >= 3) return;
      var a = sub(step); a[STEPS[step].id] = key;
      setMatch(Logic.matches(catalog, a, rate));
    }
    function current() { var c = $('input:checked', stage); return c ? c.value : ''; }
    // Leave, then arrive: the outgoing step moves out in the direction of travel before the next one is drawn.
    function swap(dir, fn) {
      if (reduced || !started) { fn(); return; }
      busy = true;
      finder.setAttribute('data-dir', dir > 0 ? 'f' : 'b');
      finder.classList.add('is-leaving');
      setTimeout(function () { finder.classList.remove('is-leaving'); busy = false; fn(); }, 180);
    }
    function render() {
      renderTabs();
      if (step >= 3) return renderResults();
      results.hidden = true; stage.hidden = false; finder.classList.remove('is-done');
      var S = STEPS[step], base = Logic.matches(catalog, sub(step), rate);
      var opts = S.list.map(function (o) { var a = sub(step); a[S.id] = o.key; return { o: o, n: Logic.matches(catalog, a, rate).length }; }).filter(function (x) { return x.n > 0; });
      opts.push({ o: S.any, n: base.length });
      var cur = answered[S.id] ? ans[S.id] : (opts[0] ? opts[0].o.key : '');
      stage.innerHTML = '<fieldset><legend class="rf-finder__q" tabindex="-1">' + words(S.q) + '</legend>' +
        '<p class="rf-finder__hint">' + (step === 0 ? 'Start with the person. We only show gifts we can send.' : 'Choose one. You can change it later.') + '</p>' +
        '<div class="rf-finder__opts">' + opts.map(function (x, i) {
          var on = x.o.key === cur;
          return '<label class="rf-choice' + (on ? ' is-on' : '') + '" style="--i:' + i + '"><input type="radio" name="rf-f-' + S.id + '" value="' + esc(x.o.key) + '"' + (on ? ' checked' : '') + '>' +
            '<span class="rf-choice__dot" aria-hidden="true"></span><span class="rf-choice__t">' + esc(x.o.label) + '</span><span class="rf-choice__n num">' + x.n + (x.n === 1 ? ' gift' : ' gifts') + '</span>' +
            '<span class="rf-choice__chev" aria-hidden="true"><svg class="rf-i" viewBox="0 0 24 24"><path d="M9 5.5 15.5 12 9 18.5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></span></label>';
        }).join('') + '</div></fieldset>' +
        '<div class="rf-finder__nav">' + (step > 0 ? '<button type="button" class="rf-textbtn" data-back>Back</button>' : '<span></span>') +
        '<button type="button" class="rf-finder__go" data-next><span>' + (step === 2 ? 'Show gifts' : 'Continue') + '</span><span class="rf-sq" aria-hidden="true"><svg class="rf-i" viewBox="0 0 24 24"><path d="M4 12h15M13.5 6.5 19 12l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></span></button></div>';
      var q = $('legend', stage); if (started && q) { toTop(); q.focus({ preventScroll: true }); }
      $('[data-next]', stage).addEventListener('click', next);
      var back = $('[data-back]', stage);
      if (back) back.addEventListener('click', function () { if (busy) return; swap(-1, function () { step = Math.max(0, step - 1); pushState(); render(); }); });
      var opts$ = $('.rf-finder__opts', stage);
      $$('input', stage).forEach(function (i) {
        i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); next(); } });
        i.addEventListener('change', function () {
          $$('.rf-choice', stage).forEach(function (l) { l.classList.toggle('is-on', $('input', l).checked); });
          preview(current());
        });
      });
      if (hover) {
        $$('.rf-choice', stage).forEach(function (l) { l.addEventListener('mouseenter', function () { preview($('input', l).value); }); });
        opts$.addEventListener('mouseleave', function () { preview(current()); });
      }
      preview(cur);
    }
    function next() {
      if (busy) return;
      var S = STEPS[step], c = $('input:checked', stage);
      ans[S.id] = c ? c.value : ''; answered[S.id] = true;
      if (!started) { started = true; publish('rf_gift_finder_start', {}); }
      publish('rf_gift_finder_step_complete', { step: step + 1 });
      if (step === 2) {
        // Remember where each tile sits, so the results can grow out of the panel.
        flip = {}; $$('[data-tile]:not(.is-gone)', stack).forEach(function (t) { var r = t.getBoundingClientRect(); if (r.width) flip[t.getAttribute('data-tile')] = r; });
      }
      swap(1, function () { step++; pushState(); render(); });
    }
    function renderResults() {
      stage.hidden = true; results.hidden = false; finder.classList.add('is-done');
      var list = Logic.matches(catalog, ans, rate);
      var parts = [];
      if (ans.person) parts.push('for ' + label(0, ans.person).toLowerCase().replace(/^(her|him|mum|dad|sister|brother)$/, function (m) { return 'your ' + m; }).replace(/^your her$/, 'her').replace(/^your him$/, 'him'));
      if (ans.occasion) parts.push(OCC[ans.occasion] || 'for ' + label(1, ans.occasion).toLowerCase());
      if (ans.budget) parts.push(label(2, ans.budget).charAt(0).toLowerCase() + label(2, ans.budget).slice(1));
      publish('rf_gift_finder_complete', { results: list.length, budget_band: ans.budget || 'any' });
      var edit = '<p class="rf-finder__edit">' + STEPS.map(function (s, i) { return '<button type="button" class="rf-textbtn" data-edit="' + i + '">Change ' + s.id + '</button>'; }).join('') + '</p>';
      if (!list.length) {
        var canBroaden = !!(ans.occasion || ans.budget), set = [ans.person, ans.occasion, ans.budget].filter(Boolean).length;
        results.innerHTML = '<h2 class="rf-finder__sum" tabindex="-1">' + words(set > 1 ? 'No gifts match these answers yet.' : 'No gifts match this answer yet.') + '</h2>' + edit +
          '<div class="rf-empty__a">' + (canBroaden ? '<button type="button" class="rf-btn rf-btn--red" data-broaden><span>Show gifts for any budget and occasion</span></button>' : '<button type="button" class="rf-btn rf-btn--red" data-edit="0"><span>Choose someone else</span></button>') + '<a class="rf-textlink" href="/collections/all">Every gift</a></div>';
      } else {
        results.innerHTML = '<h2 class="rf-finder__sum" tabindex="-1">' + words(list.length + (list.length === 1 ? ' gift ' : ' gifts ') + parts.join(', ') + '.') + '</h2>' + edit +
          '<div class="rf-grid">' + list.map(function (p, i) {
            var img = p.img ? '<img class="rf-card__img" src="' + esc(p.img) + '" alt="" width="600" height="600" loading="lazy">' : '<span class="rf-card__ph">' + esc(p.name) + '</span>';
            return '<a class="rf-card" style="--i:' + i + '" href="' + esc(p.url) + '" data-result="' + p.id + '"><span class="rf-card__media' + (p.cutout ? ' is-cutout' : '') + '">' + img + '</span><span class="rf-card__name">' + esc(p.name) + '</span>' +
              (p.material ? '<span class="rf-card__meta">' + esc(p.material) + '</span>' : '') + '<span class="rf-card__price">' + (p.from ? 'From ' : '') + esc(money(p.price)) + '</span></a>';
          }).join('') + '</div>';
      }
      var h = $('.rf-finder__sum', results); if (started && h) { toTop(); h.focus({ preventScroll: true }); }
      // FLIP: each card's image starts where its tile was in the match panel and settles into the grid.
      if (flip && !reduced) {
        $$('[data-result]', results).forEach(function (a) {
          var r0 = flip[a.getAttribute('data-result')], m = $('.rf-card__media', a);
          if (!r0 || !m) return;
          var r1 = m.getBoundingClientRect(); if (!r1.width) return;
          var s = (r0.width / (r1.width * 0.82)) || 1;
          var dx = (r0.left + r0.width / 2) - (r1.left + r1.width / 2), dy = (r0.top + r0.height / 2) - (r1.top + r1.height / 2);
          a.classList.add('is-flip');
          m.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
          requestAnimationFrame(function () { requestAnimationFrame(function () { a.classList.add('is-flip-go'); m.style.transform = ''; }); });
          setTimeout(function () { a.classList.remove('is-flip', 'is-flip-go'); }, 1000);
        });
      }
      flip = null;
      $$('[data-edit]', results).forEach(function (b) { b.addEventListener('click', function () { step = Number(b.getAttribute('data-edit')); started = true; pushState(); render(); }); });
      var br = $('[data-broaden]', results); if (br) br.addEventListener('click', function () { ans.occasion = ''; ans.budget = ''; pushState(); render(); });
      $$('[data-result]', results).forEach(function (a) { a.addEventListener('click', function () { publish('rf_gift_result_select', { product_id: a.getAttribute('data-result') }); }); });
    }
    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(location.search);
      ans = { person: p.get('person') || '', occasion: p.get('occasion') || '', budget: p.get('budget') || '' };
      answered = { person: p.has('person'), occasion: p.has('occasion'), budget: p.has('budget') };
      step = answered.budget ? 3 : answered.occasion ? 2 : answered.person ? 1 : 0; started = true; busy = false; render();
    });
    tabs.forEach(function (li, i) { $('button', li).addEventListener('click', function () { if (i < step && !busy) swap(-1, function () { step = i; started = true; pushState(); render(); }); }); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(placeInk, 120); }, { passive: true });
    history.replaceState({ step: step }, '', location.href);
    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeInk);
  }

  /* ---------- Collection views ---------- */
  var listEl = $('[data-list]');
  if (listEl) publish('rf_view_item_list', { list: listEl.getAttribute('data-list') });
})();
